import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {GridComponent} from './grid/grid.component';
import { IonicModule } from '@ionic/angular';
import { SlidesComponent } from './slides/slides.component';
import { TitleComponent } from './title/title.component';
import { LoadingComponent } from './loading/loading.component';
import { NoDataComponent } from './no-data/no-data.component';
import { ArticleComponent } from './article/article.component';
import { TabsComponent } from './tabs/tabs.component';
import { ButtonsComponent } from './buttons/buttons.component';
import { ViewComponent } from './view/view.component';
import { MzGridListComponent } from './grid/mz-grid-list/mz-grid-list.component';
import { MzGridListHeadComponent } from './grid/mz-grid-list-head/mz-grid-list-head.component';
import { MzButtonComponent } from './buttons/mz-button/mz-button.component';
import { MzGridListIcon1Component } from './grid/mz-grid-list-icon1/mz-grid-list-icon1.component';
import { MzGridListIcon2Component } from './grid/mz-grid-list-icon2/mz-grid-list-icon2.component';
import { MzGridListImg1Component } from './grid/mz-grid-list-img1/mz-grid-list-img1.component';
import { MzGridListImg2Component } from './grid/mz-grid-list-img2/mz-grid-list-img2.component';
import { MzButtonBgComponent } from './buttons/mz-button-bg/mz-button-bg.component';
import { MzButtonImgComponent } from './buttons/mz-button-img/mz-button-img.component';
import { MzSlideComponent } from './slides/mz-slide/mz-slide.component';
import { MzButtonLink1Component } from './buttons/mz-button-link1/mz-button-link1.component';
import { MzButtonLink2Component } from './buttons/mz-button-link2/mz-button-link2.component';
import { MzGridListNews1Component } from './grid/mz-grid-list-news1/mz-grid-list-news1.component';
import { MzGridListNews2Component } from './grid/mz-grid-list-news2/mz-grid-list-news2.component';
import { MzGridListFormComponent } from './grid/mz-grid-list-form/mz-grid-list-form.component';
import { CalendarComponent } from './calendar/calendar.component';
import {CalendarModule} from 'primeng/primeng';
import { SearchComponent } from './search/search.component';
import { MzGridOrderComponent } from './grid/mz-grid-order/mz-grid-order.component';
import {ScannerComponent} from './scanner/scanner.component';
import {EchartsComponent} from './echarts/echarts.component';
import { MzEchartsPieComponent } from './echarts/mz-echarts-pie/mz-echarts-pie.component';
import { MzGridListSlide1Component } from './grid/mz-grid-list-slide1/mz-grid-list-slide1.component';
import { MzSlideEchartsComponent } from './slides/mz-slide-echarts/mz-slide-echarts.component';
import { MzGridListVisitComponent } from './grid/mz-grid-list-visit/mz-grid-list-visit.component';
import { MzGridListVisitingComponent } from './grid/mz-grid-list-visiting/mz-grid-list-visiting.component';
import { MzGridListVisitedComponent } from './grid/mz-grid-list-visited/mz-grid-list-visited.component';
// import { HeadSaComponent } from './head-sa/head-sa.component';
// import { MzHeadSaComponent } from './head-sa/mz-head-sa/mz-head-sa.component';
import { MzHeadSaComponent } from './sfa/mz-head-sa/mz-head-sa.component';
import { MzGridListTemporaryPlanComponent } from './grid/mz-grid-list-temporary-plan/mz-grid-list-temporary-plan.component';
import { MzGridListNoticeComponent } from "./grid/mz-grid-list-notice/mz-grid-list-notice.component";
import {MapsComponent} from './maps/maps.component';
import {NearbystoreComponent} from './maps/nearbystore/nearbystore.component';
import {WalkingpathComponent} from './maps/walkingpath/walkingpath.component';
import { NoticeDetailComponent } from './notice-detail/notice-detail.component';
import { MzGridListLeaveComponent } from './grid/mz-grid-list-leave/mz-grid-list-leave.component';
import { MzGridListInterimplanComponent } from './grid/mz-grid-list-interimplan/mz-grid-list-interimplan.component';
import { SfaComponent } from './sfa/sfa.component';
import { MzHeadPgComponent } from './sfa/mz-head-pg/mz-head-pg.component';
import { MzHeadAdminComponent } from './sfa/mz-head-admin/mz-head-admin.component';
import { MzHeadSupervisorComponent } from './sfa/mz-head-supervisor/mz-head-supervisor.component';
import { MzStoremapsComponent } from './sfa/mz-storemaps/mz-storemaps.component';
import { MzButtonStatusComponent } from './buttons/mz-button-status/mz-button-status.component';
import { GridDetailComponent } from './grid-detail/grid-detail.component';
import { MzLeaveComponent } from './grid-detail/mz-leave/mz-leave.component';
import { MzNoticeComponent } from './grid-detail/mz-notice/mz-notice.component';
import { GridCalendarComponent } from './grid-calendar/grid-calendar.component';
import { MzCalendarComponent } from './grid-calendar/mz-calendar/mz-calendar.component';
import { MzPlanComponent } from './grid-calendar/mz-plan/mz-plan.component';
import { MzSchedulingComponent } from './grid-calendar/mz-scheduling/mz-scheduling.component';
import { MzGridListPlanMakingComponent } from './grid/mz-grid-list-plan-making/mz-grid-list-plan-making.component';
import { MzSalesReportMonthlyComponent } from './grid/mz-sales-report-monthly/mz-sales-report-monthly.component';
import { MzSalesReportDailyComponent } from './grid/mz-sales-report-daily/mz-sales-report-daily.component';
import { MzHeadVisitComponent } from './sfa/mz-head-visit/mz-head-visit.component';
import { MzFormSchedulingComponent } from './sfa/mz-form-scheduling/mz-form-scheduling.component';
import { MzHistoryVisitComponent } from './grid-calendar/mz-history-visit/mz-history-visit.component';
import { PersonalCenterComponent } from './personal-center/personal-center.component';
import { MzApprovalPersonComponent } from './grid/mz-approval-person/mz-approval-person.component';
import { MzScheduleApprovalComponent } from './grid/mz-schedule-approval/mz-schedule-approval.component';
import { MzLeaveApprovalComponent } from './grid/mz-leave-approval/mz-leave-approval.component';
import { MzLeaveApprovalDetailComponent } from './grid-detail/mz-leave-approval-detail/mz-leave-approval-detail.component';
import { SfaCollectionResultComponent } from './sfa/sfa-collection-result/sfa-collection-result.component';
import { SfaCollectionAppealComponent } from './sfa/sfa-collection-appeal/sfa-collection-appeal.component';
import { SfaIceboxDetailComponent } from './grid-detail/sfa-icebox-detail/sfa-icebox-detail.component';
import { SfaListIceboxInspectComponent } from './grid/sfa-list-icebox-inspect/sfa-list-icebox-inspect.component';
import { SfaListIceboxComponent } from './grid/sfa-list-icebox/sfa-list-icebox.component';
import { MzHistoryClockinComponent } from './grid-calendar/mz-history-clockin/mz-history-clockin.component';
import { SfaListImgCollectionComponent } from './grid/sfa-list-img-collection/sfa-list-img-collection.component';
import { ImgPreviewComponent } from './img-preview/img-preview.component';
import { SfaListProductsComponent } from './grid/sfa-list-products/sfa-list-products.component';
import { SfaListScoreAddComponent } from './grid/sfa-list-score-add/sfa-list-score-add.component';
import { SfaListScoreComponent } from './grid/sfa-list-score/sfa-list-score.component';
import { SfaImgCollectionCameraComponent } from './grid/sfa-img-collection-camera/sfa-img-collection-camera.component';
import { A2Component } from './a2/a2.component';
import { A2HeadPgComponent } from './a2/a2-head-pg/a2-head-pg.component';
import { A2NoticeComponent } from './a2/a2-notice/a2-notice.component';
import {A2EditeComponent} from './a2/a2-edite/a2-edite.component';
import { GridlistComponent } from './a2/gridlist/gridlist.component';
import { ListDetailComponent } from './a2/list-detail/list-detail.component';
import { A2ScanCodeSalesComponent } from './a2/a2-scan-code-sales/a2-scan-code-sales.component';
import { A2DailyBillInquiryComponent } from './a2/a2-daily-bill-inquiry/a2-daily-bill-inquiry.component';
import { A2SalesOrderQueryComponent } from './a2/a2-sales-order-query/a2-sales-order-query.component';
import { A2ReminderDetailComponent } from './a2/a2-reminder-detail/a2-reminder-detail.component';
import { A2ReminderListComponent } from './a2/a2-reminder-list/a2-reminder-list.component';
import { A2ProductDistributionComponent } from './a2/a2-product-distribution/a2-product-distribution.component';
import { A2ProductInventoryComponent } from './a2/a2-product-inventory/a2-product-inventory.component';
import { A2NaturalDistributionComponent } from './a2/a2-natural-distribution/a2-natural-distribution.component';
import { A2ActivityCenterComponent } from './a2/a2-activity-center/a2-activity-center.component';
import { A2ActivityCenterDetailComponent } from './a2/a2-activity-center-detail/a2-activity-center-detail.component';
import { A2GiftInventoryComponent } from './a2/a2-gift-inventory/a2-gift-inventory.component';
import { A2GeneralListComponent } from './a2/a2-general-list/a2-general-list.component';
import { A2VipScoreComponent } from './a2/a2-vip-score/a2-vip-score.component';
import { A2SignListComponent } from './a2/a2-sign-list/a2-sign-list.component';
import { A2GeneralDetailComponent } from './a2/a2-general-detail/a2-general-detail.component';
import { A2GiftViewComponent } from "./a2/a2-gift-view/a2-gift-view.component";
import { A2StoreReceiveComponent } from './a2/a2-store-receive/a2-store-receive.component';
import { A2ProductFreshnessComponent } from './a2/a2-product-freshness/a2-product-freshness.component';
import { A2PriceCheckComponent } from './a2/a2-price-check/a2-price-check.component';
import { A2SalesReportComponent } from './a2/a2-sales-report/a2-sales-report.component';
import { PosmListComponent } from './a2/posm-list/posm-list.component';
import { A2StoreDetailComponent } from './a2/a2-store-detail/a2-store-detail.component';
import { A2BindStoreComponent } from './a2/a2-bind-store/a2-bind-store.component';
import { A2ActivityCenterDetail2Component } from './a2/a2-activity-center-detail2/a2-activity-center-detail2.component';
import { A2ListVistplanComponent } from './grid/a2-list-vistplan/a2-list-vistplan.component';
import { A2ListVistplanListComponent } from './grid/a2-list-vistplan-list/a2-list-vistplan-list.component';
import { A2MilkcodeUseInfoComponent } from './a2/a2-milkcode-use-info/a2-milkcode-use-info.component';
import { A2SalesSummaryKPIComponent } from './a2/a2-sales-summary-kpi/a2-sales-summary-kpi.component';
import { QcCustomerListComponent } from './qc/qc-customer-list/qc-customer-list.component';
import { QcCustomerDetailComponent } from './qc/qc-customer-detail/qc-customer-detail.component';
import { QcCustomerconnectDetailComponent } from './qc/qc-customerconnect-detail/qc-customerconnect-detail.component';
import { QcCustomerTagComponent } from './qc/qc-customer-tag/qc-customer-tag.component';
import { QcCustomerEntryComponent } from './qc/qc-customer-entry/qc-customer-entry.component';
import { ViplistComponent } from './qc/viplist/viplist.component';
import { ReturnGoodsListComponent } from './qc/return-goods-list/return-goods-list.component';
import { ReturnGoodsDetailComponent } from './qc/return-goods-detail/return-goods-detail.component';
import { A2SampleGiftSelectionComponent } from './a2/a2-sample-gift-selection/a2-sample-gift-selection.component';
import { ScanningHomingComponent } from './a2/scanning-homing/scanning-homing.component';
import { ApprovalistManagementComponent } from './grid-calendar/approvalist-management/approvalist-management.component';
import { ApprovalSelectionManagementComponent } from './grid-calendar/approval-selection-management/approval-selection-management.component';
import { MzAddScheduleComponent } from './grid-calendar/mz-add-schedule/mz-add-schedule.component';
import { NestleCrmComponent } from './nestle-crm/nestle-crm.component';
import { ProductStorageComponent } from './nestle-crm/product-storage/product-storage.component';
import { GiftReceiptListComponent } from './nestle-crm/gift-receipt-list/gift-receipt-list.component';
import { TransferGiftsListComponent } from './nestle-crm/transfer-gifts-list/transfer-gifts-list.component';
import { QcAuditManageListComponent } from './nestle-crm/qc-audit-manage-list/qc-audit-manage-list.component';
import { GiftReceiptComponent } from './nestle-crm/gift-receipt/gift-receipt.component';
import { InventoryCheckListComponent } from './nestle-crm/inventory-check-list/inventory-check-list.component';
import { GiftInventoryFormComponent } from './nestle-crm/gift-inventory-form/gift-inventory-form.component';
import { InventoryAuditListComponent } from './nestle-crm/inventory-audit-list/inventory-audit-list.component';
import { TransferGiftsFormComponent } from './nestle-crm/transfer-gifts-form/transfer-gifts-form.component';
import { TransferGiftsDetailComponent } from './nestle-crm/transfer-gifts-detail/transfer-gifts-detail.component';
import { TransferGiftsListSrlComponent } from './nestle-crm/transfer-gifts-list-srl/transfer-gifts-list-srl.component';
import { GiftAuditDetailComponent } from './nestle-crm/gift-audit-detail/gift-audit-detail.component';
import { GiftAuditListComponent } from './nestle-crm/gift-audit-list/gift-audit-list.component';
import { QuestionnaireComponent } from './nestle-crm/questionnaire/questionnaire.component';
import { QuestionnaireInvestigationComponent } from './nestle-crm/questionnaire-investigation/questionnaire-investigation.component';
import { PotentialMembersListComponent } from './nestle-crm/potential-members-list/potential-members-list.component';
import { PotentialMembersDetailComponent } from './nestle-crm/potential-members-detail/potential-members-detail.component';
import { PotentialMemberslistPageModule } from './nestle-crm/potential-memberslist/potential-memberslist.module';
import { ContentLibraryDetailsComponent } from './nestle-crm/content-library-details/content-library-details.component';
import { A2SalesNewreportComponent } from './a2/a2-sales-newreport/a2-sales-newreport.component';

//内容库首页
import { ContentLibraryHomeComponent } from './nestle-crm/content-library/content-library-home/content-library-home.component';
import { ContentLibraryListComponent } from './nestle-crm/content-library/content-library-list/content-library-list.component';
import { ContentLibraryDetailComponent } from './nestle-crm/content-library/content-library-detail/content-library-detail.component';
import { NestmomGroupComponent } from './nestle-crm/content-library/nestmom-group/nestmom-group.component';
import { EvaluationManagementComponent } from './nestle-crm/content-library/evaluation-management/evaluation-management.component';
import { NewCouncilorKpiComponent } from './nestle-crm/new-councilor-kpi/new-councilor-kpi.component';
import { InventoryapprovalManagerComponent } from './nestle-crm/inventoryapproval-manager/inventoryapproval-manager.component';
import { A2OrderWithoutcodeComponent } from './a2/a2-order-withoutcode/a2-order-withoutcode.component';
// 赠品库存查看
import { GiftinventoryInventoryCheckComponent } from './nestle-crm/giftinventory-inventory-check/giftinventory-inventory-check.component';
import { ProductInventoryApprovalComponent } from './nestle-crm/product-inventory-approval/product-inventory-approval.component';


@NgModule({
declarations:[
    GridComponent,
    SlidesComponent,
    TitleComponent,
    LoadingComponent,
    NoDataComponent,
    ArticleComponent,
    TabsComponent,
    ButtonsComponent,
    ViewComponent,
    MzGridListComponent,
    MzGridListHeadComponent,
    MzButtonComponent,
    MzGridListIcon1Component,
    MzGridListIcon2Component,
    MzGridListImg1Component,
    MzGridListImg2Component,
    MzButtonBgComponent,
    MzButtonImgComponent,
    MzSlideComponent,
    MzButtonLink1Component,
    MzButtonLink2Component,
    MzGridListNews1Component,
    MzGridListNews2Component,
    MzGridListFormComponent,
    CalendarComponent,
    SearchComponent,
    MzGridOrderComponent,
    ScannerComponent,
    EchartsComponent,
    MzEchartsPieComponent,
    MzGridListSlide1Component,
    MzSlideEchartsComponent,
    MzGridListVisitComponent,
    MzGridListVisitingComponent,
    MzGridListVisitedComponent,
    MzHeadSaComponent,
    MzGridListTemporaryPlanComponent,
    MzGridListNoticeComponent,
    MapsComponent,
    NearbystoreComponent,
    WalkingpathComponent,
    NoticeDetailComponent,
    MzGridListLeaveComponent,
    MzGridListInterimplanComponent,
    MzHeadPgComponent,
    MzHeadAdminComponent,
    MzHeadSupervisorComponent,
    SfaComponent,
    MzStoremapsComponent,
    MzButtonStatusComponent,
    GridDetailComponent,
    MzLeaveComponent,
    MzNoticeComponent,
    GridCalendarComponent,
    MzCalendarComponent,
    MzPlanComponent,
    MzSchedulingComponent,
    MzGridListPlanMakingComponent,
    MzSalesReportMonthlyComponent,
    MzSalesReportDailyComponent,
    MzHeadVisitComponent,
    MzFormSchedulingComponent,
    MzHistoryVisitComponent,
    PersonalCenterComponent,
    MzApprovalPersonComponent,
    MzScheduleApprovalComponent,
    MzLeaveApprovalComponent,
    MzLeaveApprovalDetailComponent,
    SfaCollectionResultComponent,
    SfaCollectionAppealComponent,
    SfaIceboxDetailComponent,
    SfaListIceboxInspectComponent,
    SfaListIceboxComponent,
    MzHistoryClockinComponent,
    SfaListImgCollectionComponent,
    ImgPreviewComponent,
    SfaListProductsComponent,
    SfaListScoreAddComponent,
    SfaListScoreComponent,
    SfaImgCollectionCameraComponent,
    A2Component,
    A2HeadPgComponent,
    A2NoticeComponent,
    A2EditeComponent,
    GridlistComponent,
    ListDetailComponent,
    A2ScanCodeSalesComponent,
    A2DailyBillInquiryComponent,
    A2SalesOrderQueryComponent,
    A2ReminderDetailComponent,
    A2ReminderListComponent,
    A2ProductDistributionComponent,
    A2ProductInventoryComponent,
    A2NaturalDistributionComponent,
    A2ActivityCenterComponent,
    A2ActivityCenterDetailComponent,
    A2GiftInventoryComponent,
    A2GeneralListComponent,
    A2VipScoreComponent,
    A2SignListComponent,
    A2GeneralDetailComponent,
    A2GiftViewComponent,
    A2StoreReceiveComponent,
    A2ProductFreshnessComponent,
    A2PriceCheckComponent,
    A2SalesReportComponent,
    PosmListComponent,
    A2StoreDetailComponent,
    A2BindStoreComponent,
    A2ActivityCenterDetail2Component,
    A2ListVistplanComponent,
    A2ListVistplanListComponent,
    A2MilkcodeUseInfoComponent,
    A2SalesSummaryKPIComponent,
    QcCustomerListComponent,
    QcCustomerDetailComponent,
    QcCustomerconnectDetailComponent,
    QcCustomerTagComponent,
    QcCustomerEntryComponent,
    ViplistComponent,
    ReturnGoodsListComponent,
    ReturnGoodsDetailComponent,
    A2SampleGiftSelectionComponent,
    ScanningHomingComponent,
    ApprovalistManagementComponent,
    ApprovalSelectionManagementComponent,
    MzAddScheduleComponent,
    NestleCrmComponent,
    ProductStorageComponent,
    GiftReceiptComponent,
    GiftReceiptListComponent,
    TransferGiftsListComponent,
    QcAuditManageListComponent,
    InventoryCheckListComponent,
    GiftInventoryFormComponent,
    InventoryAuditListComponent,
    TransferGiftsDetailComponent,
    TransferGiftsFormComponent,
    TransferGiftsListSrlComponent,
    GiftAuditListComponent,
    GiftAuditDetailComponent,
    GiftAuditDetailComponent,
    GiftAuditListComponent,
    TransferGiftsDetailComponent,
    TransferGiftsFormComponent,
    TransferGiftsListSrlComponent,
    QuestionnaireComponent,
    QuestionnaireInvestigationComponent,
    PotentialMembersListComponent,
    PotentialMembersDetailComponent,
    ContentLibraryHomeComponent,
    ContentLibraryListComponent,
    ContentLibraryDetailComponent,
    PotentialMembersDetailComponent,
    ContentLibraryDetailsComponent,
    NestmomGroupComponent,
    EvaluationManagementComponent,
    A2SalesNewreportComponent,
    NewCouncilorKpiComponent,
    InventoryapprovalManagerComponent,
    A2OrderWithoutcodeComponent,
    GiftinventoryInventoryCheckComponent,
    ProductInventoryApprovalComponent
],
imports:[CommonModule,IonicModule,FormsModule,CalendarModule],
exports:[
    GridComponent,
    SlidesComponent,
    TitleComponent,
    LoadingComponent,
    NoDataComponent,
    ArticleComponent,
    TabsComponent,
    ButtonsComponent,
    ViewComponent,
    ViewComponent,
    MzGridListComponent,
    MzGridListHeadComponent,
    MzButtonComponent,
    MzGridListIcon1Component,
    MzGridListIcon2Component,
    MzGridListImg1Component,
    MzGridListImg2Component,
    MzButtonBgComponent,
    MzButtonImgComponent,
    MzSlideComponent,
    MzButtonLink1Component,
    MzButtonLink2Component,
    MzGridListNews1Component,
    MzGridListNews2Component,
    MzGridListFormComponent,
    CalendarComponent,
    SearchComponent,
    ScannerComponent,
    EchartsComponent,
    MzEchartsPieComponent,
    MzGridListSlide1Component,
    MzSlideEchartsComponent,
    MzGridListVisitComponent,
    MzGridListVisitingComponent,
    MzGridListVisitedComponent,
    MzHeadSaComponent,
    MzGridListTemporaryPlanComponent,
    MzGridListNoticeComponent,
    MapsComponent,
    NearbystoreComponent,
    WalkingpathComponent,
    NoticeDetailComponent,
    MzGridListLeaveComponent,
    MzGridListInterimplanComponent,
    MzHeadPgComponent,
    MzHeadAdminComponent,
    MzHeadSupervisorComponent,
    SfaComponent,
    MzStoremapsComponent,
    MzButtonStatusComponent,
    GridDetailComponent,
    MzLeaveComponent,
    MzNoticeComponent,
    GridCalendarComponent,
    MzCalendarComponent,
    MzPlanComponent,
    MzSchedulingComponent,
    MzGridListPlanMakingComponent,
    MzSalesReportMonthlyComponent,
    MzSalesReportDailyComponent,
    MzHeadVisitComponent,
    MzFormSchedulingComponent,
    MzHistoryVisitComponent,
    PersonalCenterComponent,
    MzApprovalPersonComponent,
    MzScheduleApprovalComponent,
    MzLeaveApprovalComponent,
    MzLeaveApprovalDetailComponent,
    SfaCollectionResultComponent,
    SfaCollectionAppealComponent,
    SfaIceboxDetailComponent,
    SfaListIceboxInspectComponent,
    SfaListIceboxComponent,
    MzHistoryClockinComponent,
    SfaListImgCollectionComponent,
    ImgPreviewComponent,
    SfaListProductsComponent,
    SfaListScoreAddComponent,
    SfaListScoreComponent,
    SfaImgCollectionCameraComponent,
    A2Component,
    A2HeadPgComponent,
    A2NoticeComponent,
    A2EditeComponent,
    GridlistComponent,
    ListDetailComponent,
    A2ScanCodeSalesComponent,
    A2DailyBillInquiryComponent,
    A2SalesOrderQueryComponent,
    A2ReminderDetailComponent,
    A2ReminderListComponent,
    A2ProductDistributionComponent,
    A2ProductInventoryComponent,
    A2NaturalDistributionComponent,
    A2ActivityCenterComponent,
    A2ActivityCenterDetailComponent,
    A2GiftInventoryComponent,
    A2GeneralListComponent,
    A2VipScoreComponent,
    A2SignListComponent,
    A2GeneralDetailComponent,
    A2GiftViewComponent,
    A2StoreReceiveComponent,
    A2ProductFreshnessComponent,
    A2PriceCheckComponent,
    A2SalesReportComponent,
    PosmListComponent,
    A2StoreDetailComponent,
    A2BindStoreComponent,
    NestleCrmComponent,
    A2MilkcodeUseInfoComponent,
    A2SalesSummaryKPIComponent,
    ApprovalistManagementComponent ,
    ApprovalSelectionManagementComponent,
    MzAddScheduleComponent,
    ProductStorageComponent,
    GiftReceiptListComponent,
    GiftReceiptComponent,
    TransferGiftsListComponent,
    QcAuditManageListComponent,
    InventoryCheckListComponent,
    GiftInventoryFormComponent,
    InventoryAuditListComponent,
    GiftAuditDetailComponent,
    GiftAuditListComponent,
    TransferGiftsDetailComponent,
    TransferGiftsFormComponent,
    TransferGiftsListSrlComponent,
    GiftAuditListComponent,
    GiftAuditDetailComponent,
    QuestionnaireComponent,
    PotentialMembersListComponent,
    PotentialMembersDetailComponent,
    ContentLibraryHomeComponent,
    ContentLibraryListComponent,
    ContentLibraryDetailComponent,
    PotentialMembersDetailComponent,
    ContentLibraryDetailsComponent,
    NestmomGroupComponent,
    A2SalesNewreportComponent,
    InventoryapprovalManagerComponent,
    A2OrderWithoutcodeComponent,
    GiftinventoryInventoryCheckComponent,
    ProductInventoryApprovalComponent
]
}) 
export class ComponentsModule{}